import React from "react";
import { Link } from "react-router-dom";
import "./ModalNoAuth.scss";

export const ModalNoAuth: React.FC = () => (
  <div className="modalNoAuth">
    <div className="modalNoAuthContent">
      <h4 className="modalNoAuthTitle">Уважаемые пользователи!</h4>
      <p className="modalNoAuthSubTitle">
        Это действие доступно только авторизованному пользователю. Авторизация
        займет всего несколько минут.
      </p>
    </div>
    <Link to="/registrationPage">
      <button className="modalNoAuthBtn">Авторизироваться</button>
    </Link>
  </div>
);

export default ModalNoAuth;
